import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";
import TabSwitch from "./TabSwitch"
import TabH5Nav from "./TabH5Nav"
import { useLocation, useNavigate } from "react-router";
import { scrollToTop, truncateMiddle } from "../utils";
import { useSelector } from "react-redux";
import { getUserInfo, productTypeList } from "../API";
import { shoppingCart } from "../API/card";

interface ChildComponentRef {
  handleCard: () => void;
}

const ChildComponent = forwardRef<ChildComponentRef>((props, ref) => { 
  const token = useSelector((state: any) => state?.token)
  const { t } = useTranslation();
  const [isActive, setIsActive] = React.useState(false)
  const navigate = useNavigate()

  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTop()
    // window.scrollTo(0, 0); 
  }, [pathname]);

  const [categoryLi, setCategoryLi] = React.useState<any>([])
  const handleLoad = () => {
    productTypeList()
      .then((res) => {
        setCategoryLi(res.data.filter((item: any) =>
          item.cfgName &&
          item.cfgName !== "其他" &&
          item.cfgName &&
          item.cfgName !== "全部"
        ))
      })
      .catch((err) => {
        console.log(err)
      })
  }
  useEffect(() => {
    handleLoad()
  }, [])

  const [cardLi, setCardLi]: any = React.useState([])
  const handleCard = () => {
    if (!token || pathname === '/login') { return }
    else {
      shoppingCart().then((res: any) => {
        setCardLi(res.data?.items)
      }).catch((err: any) => {
        console.log(err)
      })
    }
  }
  useEffect(() => {
    if (!!token) {
      // handleCard()
      handleUserInfo()
    }
  }, [token])
  useImperativeHandle(ref, () => ({
    handleCard
  }));

  const [userInfo, setUserInfo]: any = React.useState({});
  const handleUserInfo = () => {
    getUserInfo().then((res) => {
      setUserInfo(res.data);
    }).catch((err) => {
    });
  }

  return (
    <div className="bg-[#ffffff] sticky top-0 z-20 px-[28px] py-[16px] h5:px-[18px] h5:py-10"
      style={{
        boxShadow: "0 1px 5px rgba(0, 0, 0, .1)"
      }}>
      <div className="flex justify-between items-center">
        <img src={require("../assets/image/logo.png")}
          className="w-[156px] h-[50px] cursor-pointer h5:w-[107px] h5:h-[36px]"
          onClick={() => {
            navigate('/')
          }}
          alt="" />
        <div className="flex-1 flex justify-center items-center h5:hidden">
          <div className="text-[#181512] text-[18px] flex justify-center items-center px-[34px] py-[20px] cursor-pointer relative group">
            瀏覽商品
            <img src={require("../assets/image/icon1.png")} className="w-[12px] h-[12px] rotate-90 ml-2 transition-transform duration-300 ease-in-out group-hover:rotate-[-90deg]" alt="" />

            <div className="absolute left-0 top-[66px] bg-white rounded-[6px] py-10  opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform -translate-y-2 group-hover:translate-y-0"
              style={{
                width: 'max-content',
                boxShadow: "0 1px 5px rgba(0, 0, 0, .1)"
              }}>
              {
                categoryLi.map((item: any) => (
                  <div className="text-[#181512] text-[18px] px-20 py-[8px] cursor-pointer"
                    key={item?.id}
                    onClick={() => {
                      navigate('/category' + '?id=' + item?.id)
                      window.location.reload()
                    }
                    }>{item?.showName}</div>
                ))
              }
            </div>
          </div>
          <div className="flex justify-center items-center cursor-pointer">
            <div className="text-[#181512] text-[18px] flex justify-center items-center px-[34px] py-[20px]"
              onClick={() => {
                navigate('/exhibit')
              }}
            >
              詩肯概念展示
            </div>
          </div>
          <div className="flex justify-center items-center cursor-pointer">
            <div className="text-[#181512] text-[18px] flex justify-center items-center px-[34px] py-[20px] "
              onClick={() => {
                navigate('/scenes')
              }
              }>
              活動花絮
            </div>
          </div>
          <div className="flex justify-center items-center">
            <div className="text-[#181512] text-[18px] flex justify-center items-center px-[34px] py-[20px] cursor-pointer relative group">
              關於詩肯
              <img src={require("../assets/image/icon1.png")} className="w-[12px] h-[12px] rotate-90 ml-2 transition-transform duration-300 ease-in-out group-hover:rotate-[-90deg]" alt="" />

              <div className="absolute left-0 top-[66px] bg-white rounded-[6px] py-10  opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform -translate-y-2 group-hover:translate-y-0"
                style={{
                  width: 'max-content',
                  paddingRight: '20px',
                  boxShadow: "0 1px 5px rgba(0, 0, 0, .1)"
                }}>
                <div className="text-[#181512] text-[18px] px-20 py-[8px] cursor-pointer"
                  onClick={() => {
                    navigate('/about/history')
                  }
                  }
                >詩肯歷史</div>
                <div className="text-[#181512] text-[18px] px-20 py-[8px] cursor-pointer"
                  onClick={() => {
                    navigate('/about/news')
                  }
                  }>報道專區</div>
                <div className="text-[#181512] text-[18px] px-20 py-[8px] cursor-pointer"
                  onClick={() => {
                    navigate('/about/videos')
                  }
                  }>影音專區</div>
                <div className="text-[#181512] text-[18px] px-20 py-[8px] cursor-pointer"
                  onClick={() => {
                    navigate('/about/whyUs')
                  }
                  }>選擇詩肯</div>
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center">
            <div className="text-[#181512] text-[18px] flex justify-center items-center px-[34px] py-[20px] cursor-pointer relative group">
              會員中心
              <img src={require("../assets/image/icon1.png")} className="w-[12px] h-[12px] rotate-90 ml-2 transition-transform duration-300 ease-in-out group-hover:rotate-[-90deg]" alt="" />

              <div className="absolute left-0 top-[66px] bg-white rounded-[6px] py-10  opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform -translate-y-2 group-hover:translate-y-0"
                style={{
                  width: 'max-content',
                  paddingRight: '20px',
                  boxShadow: "0 1px 5px rgba(0, 0, 0, .1)"
                }}>
                <div className="text-[#181512] text-[18px] px-20 py-[8px] cursor-pointer"
                  onClick={() => {
                    navigate('/faq')
                  }
                  }>常見問題</div>
                <div className="text-[#181512] text-[18px] px-20 py-[8px] cursor-pointer"
                  onClick={() => {
                    if (token) {
                      navigate('/account/accountMemberLevels')
                    } else {
                      window.open('https://tawk.to/chat/6998a0174d62fa1c365da542/1jhu32na5', '_blank')
                    }
                  }}>會員等級說明</div>
                <a href="https://tawk.to/chat/6998a0174d62fa1c365da542/1jhu32na5" target="_blank" rel="noopener noreferrer">
                <div className="text-[#181512] text-[18px] px-20 py-[8px] cursor-pointer">聯絡我們</div>
                </a>
                <div className="text-[#181512] text-[18px] px-20 py-[8px] cursor-pointer"
                  onClick={() => {
                    navigate('/promotion')
                  }
                  }>重要公告</div>
              </div>
            </div>
          </div>
        </div>
        <img src={require("../assets/image/icon2.png")}
          onClick={() => {
            if (token) {
              navigate('/account')
            } else {
              navigate('/login')
            } 
          }
          }
          className="w-[16px] cursor-pointer" alt="" />
        {
          token ?
            <div className="ml-[4px] text-[#181512] text-[18px] cursor-pointer h5:hidden"
              onClick={() => {
                if (token) {
                  navigate('/account')
                } else {
                  navigate('/login')
                }
              }
              }>
              {truncateMiddle(userInfo?.username || '')}
            </div> :
            <div className="ml-[4px] text-[#181512] text-[18px] cursor-pointer"
              onClick={() => {
                navigate('/login')
              }
              }>登入/註冊</div>
        }
        {/* <div className="relative px-[16px]"
          onClick={() => {
            if (!!token) {
              navigate('/cart')
            } else {
              navigate('/login')
            }
          }
          }>
          <img src={require("../assets/image/icon3.png")} className="w-[19px]" alt="" />
          <div className="absolute top-[-20px] right-[-10px] bg-[#1f382e] h-[23px] pt-[2px] w-[23px] text-center text-[12px] text-[#ffffff] rounded-full
          h5:top-[-16px] h5:right-[-10px]">
            {cardLi?.length || 0}
          </div>
        </div> */}
        <div className="hidden h5:block">
          <TabSwitch isActive={isActive} onClickActive={(e: any) => setIsActive(e)} />
        </div>
      </div>

      <TabH5Nav categoryLi={categoryLi} isActive={isActive} />

    </div>
  );
})

export default ChildComponent;
